import { useImport } from '@debbie/cortex/dist/imports/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { load } from '../connect/utils.js';
import Errors from '../Errors.js';
const ImportPreview = (props) => {
    const preview = useImport(props.id);
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview }, () => {
            return (React.createElement(Link, { to: `/imports/${props.id}` }, lang.createdBy.goToImport));
        }, 'loading')));
};
export default ImportPreview;
//# sourceMappingURL=ImportPreview.js.map